module.exports = __webpack_public_path__ + "static/media/aviso-desocupacao.4bcc214b.webp";